import styled from '@emotion/styled';

export const ListWrapper = styled.ul`
  padding: 0;
  margin: 0 0 -8px 0;
`;
